import type {State} from '../../../reducers/types'

import type {PagerGroup, Pager} from './Pager.types'

export const getPager: (state: State, group: PagerGroup) => Pager = (state, group) =>
  state.pager[group]
